import React from 'react';
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined
    };
  }
  static getDerivedStateFromError(error) {
    //console.log("getDerivedStateFromError stack", error.stack)
    return {
      error: error.toString(),
      stack: error.stack.replace(/@[^\s]+\//g, '@/').replace(/@[^\s]+.chunk.js\:\d+\:\d+/g, '')
    };
  }
  componentDidCatch(error, errorInfo) {
    //console.error("ErrorBoundary error!", error, errorInfo)
  }
  render() {
    if (this.state.error) {
      return /*#__PURE__*/React.createElement("pre", {
        className: "error-fallback"
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: `https://gitlab.com/bittnerdevelopmentgroup/interactive-builder/-/issues/new?issue[title]=${encodeURIComponent(this.state.error)}&issue[description]=${encodeURIComponent(`Error\n===\n\`${this.state.error.substring(0, 40)}\`\n\nStack\n===\n\`\`\`\n${this.state.stack}\n\`\`\`\n\n${this.props.lastPaste ? `Last Paste\n===\n\`\`\`\n${this.props.lastPaste}\n\`\`\`\n` : ''}${this.props.slateValue ? `Slate Value\n===\n\`\`\`\n${JSON.stringify(this.props.slateValue)}\n\`\`\`\n` : ''}`)}`
      }, "Create GitLab issue"), " ", /*#__PURE__*/React.createElement("i", {
        className: "bi bi-arrow-clockwise hover-opacity",
        onClick: () => {
          this.setState({
            error: undefined
          });
        }
      }), " ", this.state.error, /*#__PURE__*/React.createElement("div", {
        className: "error-stack"
      }, this.state.stack));
    }
    return this.props.children;
  }
}